import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["report", "error"]

  failed(event) {
    if (event.target !== this.reportTarget) return
    event.preventDefault()
    this.reportTarget.classList.add("pi-insights-failed")
    if (this.hasErrorTarget) this.errorTarget.classList.remove("hidden")
  }

  loaded(event) {
    if (event && event.target !== this.reportTarget) return
    this.reportTarget.classList.remove("pi-insights-failed")
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
  }

  retry() {
    this.loaded()
    this.reportTarget.reload()
  }

  refresh() {
    if (!this.hasReportTarget || !this.reportTarget.src) return

    const source = new URL(this.reportTarget.src, window.location.href)
    source.searchParams.set("refresh", "1")
    if (this.reportTarget.src === source.href) this.reportTarget.reload()
    else this.reportTarget.src = source.href
  }
}
